$(document).on('click', ".action_button.add_to_cart", function () {
  
  //   console.log($(this));
  event.preventDefault();
  $add_to_cart = $(this);
  $qty_buttons = $add_to_cart.next();
  var prodid = $(this).attr("productid");
  $qty=parseInt($(".product-quantity-box input.quantity[productId="+ prodid +"]").val());
  // 	console.log(prodid)

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async : true,
    data: {
      quantity: $qty,
      id: prodid
    },
    dataType: 'json',           
    success: function(data) {
      var main_qty=data.quantity;
      $(".product-quantity-box input.quantity[productId="+ prodid +"]").attr('disabled',true)
      $add_to_cart.hide();
      $qty_buttons.show();
      fetchCart();
      showCartLabel(prodid,main_qty);
      populateCartDropdown();
    },
    error: function() {
      alert('Oops! Something went wrong. Please try to add your product again.');
    }
  });
});
$(document).on('click', ".action_button.add_to_cart_increase", function (e) {
  e.preventDefault();
  var productId = $(this).attr("productid")
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async : true,
    data: {
      quantity: 1,
      id: $(this).attr("productid")
    },
    dataType: 'json',           
    success: function(data) {
      var main_qty=data.quantity;
      //       console.log(main_qty);
      fetchCart();
      increaseQty(productId);
      showCartLabel(productId,main_qty);
      populateCartDropdown();
    },
    error: function() {
      alert('Oops! Something went wrong. Please try to add your product again.');
    }
  });
});
$(document).on('click', ".action_button.add_to_cart_decrease", function (e) {
  e.preventDefault();
  $qty_buttons = $(this).parent();
  var productId = $(this).attr("productid")
  jQuery.getJSON('/cart.js', function(cart) {

    for(var i=0; i<cart.items.length; i++)
    {
      var item = cart.items[i];
      var itemId = item.id;

      if (itemId == productId && item.quantity > 0)
      {
        //         console.log(item.quantity, itemId, productId)

        var main_qty=(item.quantity)-1;
        if (item.quantity == 1)
        {
          $qty_buttons.hide();
          $(".product-quantity-box input.quantity[productId="+ productId +"]").attr('disabled',false)
          $qty_buttons.siblings('.action_button.add_to_cart').show();
          hideCartLabel(productId);
        }
        else{            	
          showCartLabel(productId,main_qty);
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          async : true,
          data: {
            quantity: (item.quantity)-1,
            id: productId
          },
          dataType: 'json',        
          success: function() {
            //             console.log(item.quantity);
            fetchCart();
            decreaseQty(productId);                     

            populateCartDropdown();   

          },
          error: function() {
            alert('Oops! Something went wrong.');
          }
        });
      }
    }
  });
});


// add to cart functionality on aloglia search product
$('body').on('click','#algo_search-cart', function(){
  var productId = $(this).attr('product-id');
    var data = {
      id : productId,
      quantity : 1
    }
    $.ajax({
      type : 'POST',
      url : '/cart/add.js',
      async : false,
      data : data,
      dataType : 'json',
      success : function(data){
        var main_qty=data.quantity;
        showCartLabel(productId,main_qty);
        fetchCart();
        populateCartDropdown();
        //toggleQtyButtonSearchPage();
      },
      error : function(){
        console.log('error');
      }
    });
});

$('body').on('click','.cart-change-quantity.cart-plus', function(){
  var productId = $(this).attr("productid")
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async : true,
    data: {
      quantity: 1,
      id: $(this).attr("productid")
    },
    dataType: 'json',           
    success: function(data) {
      var main_qty=data.quantity;
      $(".quantity[productid="+ productId +"]").val(main_qty).attr('disabled',true);
      fetchCart();
      showCartLabel(productId,main_qty);
      populateCartDropdown();
    },
    error: function() {
      alert('Oops! Something went wrong. Please try to add your product again.');
    }
  });
});
$('body').on('click','.cart-change-quantity.cart-minus', function(){
//   var itemhandle = $(this).parents('.product-item-cta').attr('page-url').split('/products/')[1];
//   var qty = parseInt($(this).parents('.product-item-cta').find('#quantity').val());
//   if(qty > 1){
//     qty = qty - 1;
//   }else{
//     qty = 1;
//   }
//   $(this).parents('.product-item-cta').find('#quantity').val(qty)
//   $.getJSON('/products/'+itemhandle+'.json', function(product){
//     var variantid = product.product.variants[0].id;
//     var data = {
//       id : variantid,
//       quantity : qty
//     }
//     $.ajax({
//       type : 'POST',
//       url : '/cart/change.js',
//       async : false,
//       data : data,
//       dataType : 'json',
//       success : function(success){
//         fetchCart();
//         populateCartDropdown();
//       },
//       error : function(){
//         console.log('error');
//       }
//     });
//   });
  var productId = $(this).attr("productid")
  jQuery.getJSON('/cart.js', function(cart) {

    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
      var itemId = item.id;

      if (itemId == productId && item.quantity > 0)
      {
        //         console.log(item.quantity, itemId, productId)

        var main_qty=(item.quantity)-1;
        if (item.quantity == 1)
        {
          $(".quantity[productid="+ productId +"]").val(item.quantity).attr('disabled',false);
          $(".plus_minus-box[productid="+ productId +"]").hide();
          //$(".product-quantity-box input.quantity[productId="+ productId +"]").attr('disabled',false)
          $(".cart-button_box[productid="+ productId +"]").show();
          hideCartLabel(productId);
        }
        else{ 
          $(".quantity[productid="+ productId +"]").val(main_qty).attr('disabled',true);
          showCartLabel(productId,main_qty);
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          async : true,
          data: {
            quantity: (item.quantity)-1,
            id: productId
          },
          dataType: 'json',        
          success: function() {
            //             console.log(item.quantity);
            fetchCart();
            decreaseQty(productId);                     

            populateCartDropdown();   

          },
          error: function() {
            alert('Oops! Something went wrong.');
          }
        });
      }
    }
  });
});

// keyup function
$('#search-bar-input').keyup(function(){
  algoSearchLabel();
});

$('body').on('click','.ais-Pagination-link, .ais-RefinementList-item label', function(){
  console.log('pagination');
 document.querySelector('.algolia-fullsearch-container').scrollTo(0, 0);
  algoSearchLabel();
});

function algoSearchLabel(){
  jQuery.getJSON('/cart.js', function(cart) {
    for(var i=0; i<cart.items.length; i++){
      var item = cart.items[i];
      var itemId = item.id;
      var itemQty = item.quantity;
      $(".plus_minus-box[productid="+ itemId +"]").css('display','flex');
      $(".cart-button_box[productid="+ itemId +"]").hide();
      $(".quantity[productid="+ itemId +"]").val(itemQty).attr('disabled',true);
      showCartLabel(itemId,itemQty);
    }




  });
}

$('body').on('click','button.js-add', function(){
  $(this).parent().css('display','none');
  $(this).parents('.add_quantity-box').find('.plus_minus-box').css('display','flex');
});

function fetchCart ()
{
 /* jQuery.getJSON('/cart.js', function(cart) {
    var cartPrice = parseFloat(cart.original_total_price/100).toFixed(2);
    $('.cart-item__count').html(cart.item_count);
    $('.cart-item__count~strong').html(cartPrice);
  });*/

document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
   bubbles: true
  }));
//document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
}

function showCartLabel (prodid,main_qty)
{
  $(".add-to-cart-btn[productid='"+ prodid +"'] .pr_wrap_qty").html(main_qty);
  $(".add-to-cart-btn[productid='"+ prodid +"']").show();
}

function hideCartLabel (prodid)
{
  console.log($(".add-to-cart-btn[productid='"+ prodid +"']"))
  $(".add-to-cart-btn[productid='"+ prodid +"']").hide();
}

function increaseQty (productId)
{
  var current_qty = parseInt($(".product-quantity-box input.quantity[productId="+ productId +"]").val())
  if (current_qty > 0)
  {
    $(".product-quantity-box input.quantity[productId='"+ productId +"']").val(current_qty + 1); 
  }
}

function decreaseQty (productId)
{
  var current_qty = parseInt($(".product-quantity-box input.quantity[productId="+ productId +"]").val());
  if (current_qty > 1)
  {
    $(".product-quantity-box input.quantity[productId='"+ productId +"']").val(current_qty - 1); 
  }
}

function populateCartDropdown ()
{
  $.getJSON('/cart.js', function(cart) {
    $( ".cart-dropdown ul li" ).hide();
    for(var i=0; i<cart.items.length; i++)
    {
      var item = cart.items[i];
      var item_price = (item.price / 100).toFixed(2);
      var item_title = item.product_title;
      var item_image = item.image;
      var cart_total = (cart.total_price / 100).toFixed(2);

      $line_item = "<li><img src=" + item_image + "><p class='item-title'>" + item_title + "</p><p class='item-price'>$" + item_price + "</p></li>";
      $( ".cart-dropdown ul" ).append($line_item);
      $('.dropdown-cart-total span').html('$' + cart_total)
    }
  });
}



$(document).ready(function(){
  $('.multi_select_product_info').change(function(){
  var selvar =$(this).val();
    //  alert(selvar);
    $('.action_button.add_to_cart').attr("productid",selvar);
    $(".action_button.add_to_cart_increase").attr("productid",selvar);
    $(".action_button.add_to_cart_decrease").attr("productid",selvar);
    var variant=selvar;
  });
  
  $('.action_button').click(function(){
  //alert($('.product_info_variant').val());
 var sel= $('.multi_select_product_info').val();
   // alert(sel);
  });
  
  
  
   $('.banner-form__custom #customer_login .waves-input-wrapper').after( '<p class="password-recover-modal-login-link-home"><span style="color: #47aa42;cursor: pointer;">Forgot Password?</span></p>');
  
   $('body').delegate('.password-recover-modal-login-link-home','click',function() {
       
        $('body').addClass('modal-open');
        $('body').append('<div class="modal-backdrop fade show"></div>');
        $('#signUp').addClass('show');
        $('#signUp').removeAttr('aria-hidden');
        $('#signUp').attr('aria-modal','true');
     	$('.model-password-recover').show();
        $('.modal-signup-form').hide()
     	$('#signUp').show();
	});
   $('.close_sign_up_form').click(function(){
      $('.model-password-recover').hide();
      $('.modal-signin-form').hide();
      $('.modal-signup-form').show();
   });
  
   $('.signUp-modal-login-link').click(function(){
      $('.model-password-recover').hide();
      $('.modal-signin-form').show();
      $('.modal-signup-form').hide();
   });
   
  

  })

  const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
 
  autocomplete({
    container: '#autocomplete',
    placeholder: 'Search for products',
    getSources({ query }) {
      const state = {
      hasCollectionTitle: false
    };
      return [
        {
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'aone_products',
                  query,
                  params: {
                    hitsPerPage: 8,
                  },
                },
                {
                  indexName: 'aone_collections',
                  query,
                  params: {
                    hitsPerPage: 5,
                  },
                },
              ],
            });
          },
          templates: {
            item({ item, html, source }) {
              if (item.__autocomplete_indexName === 'aone_products') {
                return html`
                  <div class="aa-suggestion" role="option" id="option-${item.objectID}">
                    <a href="/products/${item.handle}">
                      <div data-algolia-objectid="${item.objectID}" class="aa-product" style="white-space: normal;">
                        <div class="aa-product-picture" style="background-image: url('${item.product_image}')"></div>
                        <div class="aa-product-text">
                          <p class="aa-product-title">${item.title}</p>
                          <p class="aa-product-info">${item.product_type} by ${item.vendor}</p>
                          <p class="aa-product-price"><b>$${parseFloat(item.price).toFixed(2)}</b></p>
                        </div>
                      </div>
                    </a>
                  </div>
                `;
              } else if (item.__autocomplete_indexName === 'aone_collections') {
                if (!state.hasCollectionTitle) {
                  state.hasCollectionTitle = true;
                  return html`
                    <div class="aa-collections-title">
                      <span>Collections</span>
                    </div>
                    <div class="aa-suggestion" role="option" id="option-${item.objectID}">
                      <a href="/collections/${item.handle}">
                        <div data-algolia-objectid="${item.objectID}" class="aa-collection" style="white-space: normal;">
                          <div class="aa-collection-text">
                            <p class="aa-collection-title">${item.title}</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  `;
                } else {
                  return html`
                    <div class="aa-suggestion" role="option" id="option-${item.objectID}">
                      <a href="/collections/${item.handle}">
                        <div data-algolia-objectid="${item.objectID}" class="aa-collection" style="white-space: normal;">
                          <div class="aa-collection-text">
                            <p class="aa-collection-title">${item.title}</p>
                          </div>
                        </div>
                      </a>
                    </div>
                  `;
                }
              }
            },
          },
        },
      ];
    },
  });
//related products 

const axios = require('axios');

// Define the URL and headers
const url = 'https://TJRHS6K5IH-dsn.algolia.net/1/indexes/aone_products/query';
const headers = {
  'X-Algolia-Application-Id': 'TJRHS6K5IH',
  'X-Algolia-API-Key': '0f26d3d5e34f4205c4d22a86b7236d84',
  'Content-Type': 'application/json'
};

// Define the request body
const newbody = {
  query: '', // Empty query to get all results
  hitsPerPage: 10
};

// Make the request
axios.post(url, newbody, { headers: headers })
  .then(response => {
    console.log('Search results:', response.data.hits);
  })
  .catch(error => {
    console.error('Error fetching products:', error);
  });
